import { api } from '@/axios-config';
import store from '../store/store';

export default {
  created() {
    this.getPageData();
  },
  data() {
    return {
      pageData: null,
      dataLoaded: false,
    };
  },
  methods: {
    getPageData() {
      let pageToGet;
      if (this.currentlang === 'de') {
        pageToGet = this.pageID.de;
      } else {
        pageToGet = this.pageID.fr;
      }
      api
        .get(`pages/${pageToGet}`)
        .then(response => {
          this.pageData = response.data;
          this.dataLoaded = true;
        })
        .catch(error => {
          console.error(`😱😱😱 getPage error: ${error}`);
        });
    },
  },
  computed: {
    currentlang() {
      return store.state.i18n.locale;
    },
  },
  watch: {
    currentlang() {
      this.getPageData();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/getPage.js